/**
 * perChildDeclarations — декларациите, чиито данни са ЛИЧНИ за всяко дете (задача 41).
 *
 * Формата за подпис предлага „За всички деца" и тогава подписва ЕДИН И СЪЩ формуляр за всяко
 * избрано дете. При медицинската декларация това значи, че алергиите, заболяванията и
 * лекарствата на едно дете се записват и за братята и сестрите му — и влизат в спешните им
 * карти, които учителят отваря при инцидент. Грешни медицински данни в спешна карта са по-лоши
 * от липсващи. Решение на owner-а (23.09.2026): за тези декларации „За всички" НЕ се предлага.
 *
 * 🔴 ЕДИН източник: пита САМО хукът (`useSignModal`); `ChildSelector` получава решението като проп
 * (`allowAllChildren`). Друга декларация с данни на ниво дете влиза в това множество, не в
 * компонента — ⚠️ тогава и обяснението (`signModal.childSelector.perChildOnly`, днес за медицинската)
 * трябва да стане общо или по код, иначе ще казва „медицинската" за друга декларация.
 * 📌 `EMERGENCY_CONTACTS` НЕ е тук нарочно — по решение на owner-а остава с „За всички".
 */

/** Кодовете, които се подписват само за ЕДНО дете наведнъж. */
export const PER_CHILD_DECLARATION_CODES = ['MEDICAL_INFO'] as const;

/** Подписва ли се декларацията само за ЕДНО дете наведнъж (без „За всички деца"). */
export function isPerChildDeclaration(declarationCode: string | null | undefined): boolean {
  return (PER_CHILD_DECLARATION_CODES as readonly string[]).includes(declarationCode ?? '');
}
